export type WebsiteAddress = {
  /** The normalised address that is saved: the origin and a trailing slash. */
  href: string;
  /** What the person recognises it by: the hostname without a leading www. */
  host: string;
};

/**
 * Reads what someone typed into "Website address". `yourstore.com` is as good as
 * `https://yourstore.com/pricing?x=1`: the scheme is added when it is missing, anything
 * after the host is dropped, and a name with no top-level domain is not an address.
 * Null for anything else, including an empty field.
 */
export function parseWebsiteAddress(raw: string): WebsiteAddress | null {
  const value = raw.trim();
  if (!value) return null;

  try {
    const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
    if (!/^https?:$/.test(url.protocol) || !/\.[a-z]{2,}$/i.test(url.hostname)) return null;
    return { href: `${url.origin}/`, host: url.hostname.replace(/^www\./, '') };
  } catch {
    return null;
  }
}
